module.exports = __webpack_public_path__ + "static/img/7.71d8d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/7.png
// module id = iFSD
// module chunks = 0